
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class PromocodeService extends CommonService {
  async getPromocodes(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`promocodes/?${query}`);
  }
  async generatePromocodes(parmas: { [key: string]: boolean | string }) {
    return await this.post('promocodes/bulk-create', parmas)
  }

  async getPromocodesExcel(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`promocodes/excel?${query}`);
  }

  async generatePromocodesExcel(parmas: { [key: string]: boolean | string }) {
    return await this.post('promocodes/excel', parmas)
  }

  async downloadExcel(parmas: { [key: string]: boolean | string }) {
    return await this.post('promocodes/excel-download', parmas)
  }

  async promocodesValidate(parmas: { [key: string]: boolean | string }) {
    return await this.post('promocodes/validate', parmas)
  }

  async updatePromoCode(id: string, params: { [key: string]: boolean | string }) {
    return await this.put(`promocodes/${id}`, params)
  }
}
export const promocodeService = new PromocodeService();
